import React from 'react'
import { Header, Container, Form, Input, Button, Label } from 'semantic-ui-react'

export default class LoginPageLayout extends React.Component {

  state = {
    data: {
      login: '',
      password: '',
    },
    errors: {},
  }

  containerStyle = { width: '350px', marginTop: '100px' }

  handleChange = (field) => (e, { value }) => {
    const errors = { ...this.state.errors }
    delete errors[field]
    this.setState({
      errors,
      data: {
        ...this.state.data,
        [field]: value,
      },
    })
  }

  validate = () => {
    const errors = {}
    const { data } = this.state
    if (!data.login) {
      errors.login = 'Введите имя пользователя'
    }
    if (!data.password) {
      errors.password = 'Введите пароль'
    }
    this.setState({
      errors,
    })
    return !Object.keys(errors).length
  }

  handleSubmit = (e) => {
    if (e) { e.preventDefault() }
    if (this.validate()) {
      this.props.onLogin(this.state.data)
    }
  }

  render() {
    const { isLoggingIn } = this.props
    const { data: { login, password }, errors } = this.state
    return (
      <Container style={this.containerStyle} textAlign='center'>
        <Header>Globe3D Dashboard Login</Header>
        <Form onSubmit={this.handleSubmit} ref={ref => this.form = ref}>
          <Form.Field error={!!errors.login}>
            <label>Имя пользователя</label>
            <Input name='login' value={login} onChange={this.handleChange('login')}/>
            {errors.login && <Label pointing basic color='red' content={errors.login}/>}
          </Form.Field>
          <Form.Field error={!!errors.password}>
            <label>Пароль</label>
            <Input name='password' value={password} onChange={this.handleChange('password')} type='password'/>
            {errors.password && <Label pointing basic color='red' content={errors.password}/>}
          </Form.Field>
          <Button
            disabled={isLoggingIn}
            loading={isLoggingIn}
            color='blue'
            basic
            fluid
            content='Войти'
            onClick={this.handleSubmit}
          />
        </Form>
      </Container>
    )
  }
}